import { render } from "./social_post.vue?vue&type=template&id=2f9e8af4&scoped=true"
import script from "./social_post.vue?vue&type=script&lang=js"
export * from "./social_post.vue?vue&type=script&lang=js"

import "./social_post.vue?vue&type=style&index=0&id=2f9e8af4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9e8af4"]])

export default __exports__